import { z } from "zod";

export const calendarExcludeDaySchema = z.object({
  date: z.date(),
  label: z
    .string()
    .min(1, "Nazwa dnia wolnego jest wymagana.")
    .max(100, "Nazwa dnia wolnego jest za długa, maksymalnie 100 znaków"),
});
